export const DeviceInfo = {
  options: [],
  header: [
    navigator.platform,
    window.navigator.userAgent,
    navigator.appVersion,
    navigator.vendor,
    window.opera,
  ],
  dataos: [
    { name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
    { name: 'Windows', value: 'Win', version: 'NT' },
    { name: 'iPhone', value: 'iPhone', version: 'OS' },
    { name: 'iPad', value: 'iPad', version: 'OS' },
    { name: 'Kindle', value: 'Silk', version: 'Silk' },
    { name: 'Android', value: 'Android', version: 'Android' },
    { name: 'PlayBook', value: 'PlayBook', version: 'OS' },
    { name: 'BlackBerry', value: 'BlackBerry', version: '/' },
    { name: 'Macintosh', value: 'Mac', version: 'OS X' },
    { name: 'Linux', value: 'Linux', version: 'rv' },
    { name: 'Palm', value: 'Palm', version: 'PalmOS' },
  ],
  databrowser: [
    { name: 'Edge', value: 'EdgiOS', version: 'EdgiOS' },
    { name: 'Edge', value: 'EdgA', version: 'EdgA' },
    { name: 'Edge', value: 'Edg', version: 'Edg' },
    { name: 'Chrome', value: 'CriOS', version: 'CriOS' },
    { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
    { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
    { name: 'Safari', value: 'Safari', version: 'Version' },
    { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
    { name: 'Opera', value: 'Opera', version: 'Opera' },
    { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
    { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' },
  ],
  init: function () {
    let agent = this.header.join(' '),
      os = this.matchItem(agent, this.dataos),
      browser = this.matchBrowser(agent, this.databrowser);
    return { os: os, browser: browser };
  },
  matchItem: function (string, data) {
    let i = 0,
      regex,
      regexv,
      match,
      matches,
      version;
    for (i = 0; i < data.length; i += 1) {
      regex = new RegExp(data[i].value, 'i');
      match = regex.test(string);
      if (match) {
        regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
        matches = string.match(regexv);
        version = '';
        if (matches && matches[1]) {
          matches = matches[1];
        }
        if (matches) {
          matches = matches.split(/[._]+/);
          version = matches.join('.');
        } else {
          version = '0';
        }
        return {
          name: data[i].name,
          version: version,
        };
      }
    }
    return { name: 'unknown', version: 0 };
  },
  matchBrowser: function (string, data) {
    let i = 0,
      regex,
      regexv,
      match,
      matches,
      version;
    for (i = 0; i < data.length; i += 1) {
      regex = new RegExp(data[i].value, 'i');
      match = regex.test(string);
      if (match) {
        regexv = new RegExp(data[i]?.version + '[- /:;]([\\d._]+)', 'i');
        matches = string.match(regexv);
        version = '';
        if (matches) {
          matches = matches[1] ? matches[1] : '';
        }
        if (matches) {
          matches = matches.split(/[._]+/);
          version = matches.join('.');
        } else {
          version = '0';
        }
        return {
          name: data[i].name,
          version: version,
        };
      }
    }
    return { name: 'unknown', version: 0 };
  },
};

export const DeviceInfoDataRender = () => {
  let DeviceInfoData = [];
  Object.entries({
    platform: navigator.platform,
    vendor: navigator.vendor,
    ...DeviceInfo.init(),
    codeVersion: process.env.REACT_APP_FPOO_UI_COMMIT_ID || "0.1.0",
    userAgent: navigator.userAgent,
    appVersion: navigator.appVersion,
  })?.forEach(([key, value]) => {
    if (key === 'os' || key === 'browser') {
      Object.entries(value)?.forEach(([_key, _value]) => {
        if (_key === 'name' || _key === 'version') DeviceInfoData.push(`${key}_${_key}: ${_value}`);
      });
    } else {
      DeviceInfoData.push(`${key}: ${value}`);
    }
  });
  return DeviceInfoData;
};

export const isMobileWithoutContext = () => {
  return window?.innerWidth <= 786;
};
